class EnterpriseCheckout {
  constructor( settings = {} ) {
    this.settings = settings
    this.val = 0
    this.init()
  }

  init () {
    this.cacheDOM()
    this.boundUpdatePrice = this.updatePrice.bind( this )
    this.bindEvents()

    if ( this.settings.updatePrice ) {
      this.updatePrice()
    }
  }

  cacheDOM () {
    // Pricing elements
    this.$qty = $( '#qty' )
    this.$cost = $( '#monthly_rate' )
    this.$yearlyCost = $( "#yearly_rate" )
    this.$costBox = $( '.cost_container' )

    // Checkout Summary elements
    this.$checkoutPlan = $( '#checkout_plan' )
    this.$checkoutUser = $( '#checkout_user' )
    this.$checkoutPlanUsersPrice = $( '#checkout_plan_users_price' )
    this.$checkoutTotal = $( '#checkout-total' )

    // Academy elements
    this.$academyPrice = $( '#summary-academy-price' )
    this.$academyPeriod = $( 'select#summary-academy-period' )
    this.$academyPlan = $( 'select#summary-academy-plan' )
    this.$academyUsersInput = $( 'input#summary-academy-users' )
    this.$academyPeriodTitle = $( '#academy_period_title' )
    this.$academyUsersDisplay = $( '#academy_users' )
    this.$academyTotalDisplay = $( '#academy-total' )

    // Misc Contextual inputs
    this.$plans = $( "input[name=plan]" )
    this.$offer = $( '#offer' )
    this.$mode = $( '#mode' )
    this.$verify = $( '#verify' )
    this.$invoiceLink = $( '#invoice_link' )

    // Parent layouts
    this.$costParent = this.$cost.closest( '.cost_container' )
    this.$yearlyCostParent = this.$yearlyCost.closest( '.cost_container' )

    // Configurations
    this.qmin = parseInt( this.$qty.attr( 'min' ), 10 ) || 1
  }

  bindEvents () {
    this.$plans.on( 'change', this.boundUpdatePrice )
    $( '#in5_enterprise_license' ).data( { 'update': this.boundUpdatePrice } )
    this.$qty.on( 'input blur', this.boundUpdatePrice )

    // Watch Academy Price elements for external modifications safely
    const targetNode = document.getElementById( 'summary-academy-price' )
    if ( targetNode ) {
      const observer = new MutationObserver( () => this.updatePrice() )
      observer.observe( targetNode, { childList: true, characterData: true, subtree: true } )
    }

    // Dynamic URL compiler for the invoice link
    this.$invoiceLink.on( 'click', ( e ) => {
      const selectedPlan = this.$plans.filter( ':checked' ).val() || ''
      const baseUrl = this.$invoiceLink.attr( 'href' ).split( '?' )[ 0 ] // Reset old query strings safely

      const params = $.param( {
        plan: selectedPlan,
        offer: this.$offer.val(),
        mode: this.$mode.val(),
        verify: this.$verify.val(),
        qty: this.$qty.val()
      } )

      this.$invoiceLink.attr( 'href', `${ baseUrl }?${ params }` )
    } )
  }

  updatePrice ( e ) {
    const fieldQty = parseInt( this.$qty.val(), 10 )

    // Prevent premature calculating when typing a number lower than minimum constraint
    if ( e?.type === 'input' && ( isNaN( fieldQty ) || fieldQty < this.qmin ) ) {
      return
    }

    try {
      const qty = isNaN( fieldQty ) ? this.qmin : Math.max( fieldQty, this.qmin )
      const $selectedPlanInput = this.$plans.filter( ':checked' )

      if ( !$selectedPlanInput.length ) return

      const isAnnual = $selectedPlanInput.attr( 'id' )?.includes( 'annual' )
      const seatPrice = parseInt( $selectedPlanInput.attr( 'data-price' ), 10 ) || 0
      this.val = qty * seatPrice

      // Class toggles
      this.$costBox.removeClass( 'active' )
      if ( isAnnual ) {
        this.$yearlyCostParent.addClass( 'active' )
      } else {
        this.$costParent.addClass( 'active' )
      }

      // Input value sync check
      if ( fieldQty < qty ) {
        this.$qty.val( qty )
      }

      // Render Output Strategy
      if ( this.val > 0 ) {
        this.$cost.html( `Monthly <br /> $${ this.val }<span class="duration">/mo</span>` )
        this.$yearlyCost.html( `Annual <br /> $${ this.val * 12 }<span class="duration">/year</span>` )

        const checkoutPlanText = isAnnual ? 'in5 Enterprise Plan - Annual' : 'in5 Enterprise Plan - Monthly'
        const totalPlanCost = isAnnual ? ( 12 * this.val ) : this.val

        this.$checkoutPlan.html( checkoutPlanText )
        this.$checkoutUser.html( `For ${ qty } users` )
        this.$checkoutPlanUsersPrice.html( `$${ totalPlanCost }` )

        // Parse Academy configuration details
        const academyPriceVal = parseFloat( this.$academyPrice.text().replace( /[^0-9.]/g, '' ) ) || 0
        const rawPlanText = this.$academyPlan.val() || ''

        // Capitalize function logic mapped cleanly
        const planFormatted = rawPlanText
          .split( ' ' )
          .map( word => word.charAt( 0 ).toUpperCase() + word.slice( 1 ) )
          .join( ' ' )

        if ( planFormatted && planFormatted !== 'None' ) {
          const period = this.$academyPeriod.val()
          const academyPeriodText = ( period === 'monthly' )
            ? 'Ajar Academy Video training - Monthly'
            : 'Ajar Academy Video training - Annual'

          this.$academyPeriodTitle.text( academyPeriodText )
          this.$academyUsersDisplay.text( `${ planFormatted } for ${ this.$academyUsersInput.val() } Users` )
          this.$academyTotalDisplay.text( `$${ academyPriceVal }` )
        } else {
          this.$academyPeriodTitle.text( '' )
          this.$academyUsersDisplay.text( '' )
          this.$academyTotalDisplay.text( '' )
        }

        this.$checkoutTotal.text( `$${ academyPriceVal + totalPlanCost }` )
      } else {
        this.$cost.html( 'Monthly' )
        this.$yearlyCost.html( 'Annual' )
      }

    } catch ( err ) {
      console.error( "Checkout calculation Error: ", err )
      this.val = 0
    }
  }
}

window.EnterpriseCheckout = EnterpriseCheckout